/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService
 */

export const searchRpc = {
  serviceName: 'com.hubspot.learning.center.search.rpc.SearchChirpService',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'omGUGw_oCHbhn8zzvXBi8hLuLWvMCU-G'
};
export const searchEvaluationRpc = {
  serviceName: 'com.hubspot.learning.center.search.rpc.SearchChirpService',
  rpcName: 'searchEvaluation',
  auth: 'app',
  fingerprint: 'RjYrn4VR2sBwDYMPXpHtEBLuLWvMCU-G'
};
export const sendFeedbackRpc = {
  serviceName: 'com.hubspot.learning.center.search.rpc.SearchChirpService',
  rpcName: 'sendFeedback',
  auth: 'app',
  fingerprint: 'fIdeOzo-K8jDsC48bexEPXmOv-mnC6pY'
};